import { useCallback, useEffect, useState } from "react";
import { Alert, Badge, Box, Tab, Typography, Paper } from "@mui/material";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import "./workspace.css";
import { openGlobalSnack } from "../utils/snack";
import { HS_AGENT, hsRequest } from "./api";
import { LeadChat } from "./leadchat";
import { LeadList } from "./leadlist";

/** Área do atendente: fila de leads, meus leads (com conversa), histórico. */
export function HumanSalesAgent() {
    const [tab, setTab] = useState('queue');
    const [meta, setMeta] = useState<any>(null);
    const [stats, setStats] = useState<any>(null);
    const [open, setOpen] = useState<any>(null);
    const [version, setVersion] = useState(0);

    const refresh = useCallback(async () => {
        try {
            const [m, s] = await Promise.all([hsRequest('GET', `${HS_AGENT}/meta`), hsRequest('GET', `${HS_AGENT}/stats`)]);
            setMeta(m); setStats(s);
        } catch (e: any) { openGlobalSnack(e.message, 'error'); }
    }, []);
    useEffect(() => { refresh(); }, [refresh, version]);

    function changed() { setVersion((v) => v + 1); }

    return (
        <Box className="sales-workspace">
            <Box sx={{ mb: 3 }}><Typography variant="overline" color="text.secondary">ÁREA DO COLABORADOR</Typography><Typography component="h1" variant="h4" sx={{ fontWeight: 700, fontSize: { xs: 26, md: 32 } }}>Atendimento</Typography><Typography color="text.secondary" sx={{ mt: 0.5 }}>Organize sua fila e acompanhe cada cliente até a conclusão.</Typography></Box>
            {meta && !meta.enabled ? <Alert severity="warning" sx={{ mb: 2 }}>O programa de atendimento está desativado no momento.</Alert> : null}
            {stats ? (
                <Box sx={{ display: 'grid', gridTemplateColumns: { xs: 'repeat(2, 1fr)', md: 'repeat(4, 1fr)' }, gap: 1.5, mb: 3 }}>
                    {[
                        ['Em atendimento', `${stats.active}${meta ? ` / ${meta.maxActive}` : ''}`],
                        ['Vendas concluídas', String(stats.won)],
                        ['Encerrados sem venda', String(stats.lost)],
                        ['Conversão', `${stats.conversionPercent}%`],
                    ].map(([label, value]) => <Paper key={label} variant="outlined" sx={{ p: 2, borderRadius: 3 }}><Typography variant="body2" color="text.secondary">{label}</Typography><Typography variant="h5" sx={{ mt: 0.5, fontWeight: 700 }}>{value}</Typography></Paper>)}
                </Box>
            ) : null}
            <TabContext value={tab}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <TabList aria-label="Listas de atendimento" variant="fullWidth" onChange={(_, v) => setTab(v)}>
                        <Tab label="Fila" value="queue" />
                        <Tab value="mine" label={<Badge color="primary" badgeContent={stats?.active || 0} sx={{ pr: stats?.active ? 1.5 : 0 }}>Meus clientes</Badge>} />
                        <Tab label="Histórico" value="history" />
                    </TabList>
                </Box>
                <TabPanel value="queue" sx={{ px: 0 }}><LeadList key={`q${version}`} scope="queue" meta={meta} onOpen={setOpen} onClaimed={() => { changed(); setTab('mine'); }} /></TabPanel>
                <TabPanel value="mine" sx={{ px: 0 }}><LeadList key={`m${version}`} scope="mine" meta={meta} onOpen={setOpen} onClaimed={changed} /></TabPanel>
                <TabPanel value="history" sx={{ px: 0 }}><LeadList key={`h${version}`} scope="history" meta={meta} onOpen={setOpen} onClaimed={changed} /></TabPanel>
            </TabContext>
            {open ? <LeadChat lead={open} onClose={() => setOpen(null)} onChanged={changed} /> : null}
        </Box>
    );
}
